var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _ellipse, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _ellipse2, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _ellipse3, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _g144, _g145, _ellipse4, _g146, _circle, _circle2, _g147, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcomeBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 900,
    viewBox: "0 0 1440 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 80.56,
    cy: 43.3871,
    rx: 1.56,
    ry: 1.0819,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 145.975,
    cy: 40.2074,
    rx: 0.974998,
    ry: 0.676191,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 421.305,
    cy: 38.3557,
    rx: 1.30499,
    ry: 0.905054,
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 576.005,
    cy: 49.9372,
    rx: 1.005,
    ry: 0.696995,
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 699.545,
    cy: 46.1506,
    rx: 1.54501,
    ry: 1.0715,
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 740.755,
    cy: 8.15244,
    rx: 1.755,
    ry: 1.21714,
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.97
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 993.425,
    cy: 23.1811,
    rx: 1.42499,
    ry: 0.988276,
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1018.53,
    cy: 55.8497,
    rx: 1.53,
    ry: 1.0611,
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1169.22,
    cy: 21.6485,
    rx: 1.21503,
    ry: 0.842636,
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1432.3,
    cy: 41.1297,
    rx: 1.30499,
    ry: 0.905054,
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1.305,
    cy: 112.887,
    rx: 1.305,
    ry: 0.905056,
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 279.365,
    cy: 112.235,
    rx: 1.36501,
    ry: 0.946663,
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 328.275,
    cy: 91.3662,
    rx: 1.27499,
    ry: 0.884251,
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 506.725,
    cy: 114.565,
    rx: 1.72501,
    ry: 1.19633,
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 643.11,
    cy: 76.6878,
    rx: 1.10999,
    ry: 0.769817,
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 765.9,
    cy: 89.0255,
    rx: 0.899994,
    ry: 0.624172,
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 907.455,
    cy: 92.8782,
    rx: 1.45499,
    ry: 1.00908,
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1152.19,
    cy: 112.803,
    rx: 1.185,
    ry: 0.821831,
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1274.01,
    cy: 112.678,
    rx: 1.005,
    ry: 0.696999,
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1361.11,
    cy: 107.203,
    rx: 1.10999,
    ry: 0.769817,
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 70.9,
    cy: 171.879,
    rx: 0.900002,
    ry: 0.624176,
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 161.65,
    cy: 149.513,
    rx: 1.65,
    ry: 1.14432,
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 312.14,
    cy: 167.884,
    rx: 1.14,
    ry: 0.790619,
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 485.335,
    cy: 168.713,
    rx: 1.33501,
    ry: 0.925858,
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 625.47,
    cy: 125.115,
    rx: 1.47,
    ry: 1.01949,
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 806.095,
    cy: 136.645,
    rx: 1.095,
    ry: 0.759415,
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 995.095,
    cy: 146.354,
    rx: 1.095,
    ry: 0.759415,
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1112.77,
    cy: 161.386,
    rx: 1.77002,
    ry: 1.22754,
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1281.53,
    cy: 154.284,
    rx: 1.53003,
    ry: 1.0611,
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1406.95,
    cy: 147.637,
    rx: 0.945007,
    ry: 0.65538,
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 36.29,
    cy: 230.73,
    rx: 1.29,
    ry: 0.894653,
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 184.005,
    cy: 218.049,
    rx: 1.005,
    ry: 0.696999,
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 323.68,
    cy: 236.548,
    rx: 1.67999,
    ry: 1.16512,
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 535.185,
    cy: 236.898,
    rx: 1.185,
    ry: 0.821831,
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 682.38,
    cy: 193.342,
    rx: 1.38,
    ry: 0.957062,
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 761.485,
    cy: 205.204,
    rx: 1.48499,
    ry: 1.02989,
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 936.05,
    cy: 188.951,
    rx: 1.04999,
    ry: 0.728203,
    fill: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1037.59,
    cy: 191.407,
    rx: 1.59003,
    ry: 1.10271,
    fill: "white"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1211.54,
    cy: 193.456,
    rx: 1.54498,
    ry: 1.0715,
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1298.03,
    cy: 184.086,
    rx: 1.03497,
    ry: 0.717804,
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.82
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 98.515,
    cy: 252.709,
    rx: 1.515,
    ry: 1.0507,
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 213.215,
    cy: 289.258,
    rx: 1.215,
    ry: 0.842636,
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 312.38,
    cy: 242.212,
    rx: 1.38,
    ry: 0.957069,
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 570.515,
    cy: 291.546,
    rx: 1.51501,
    ry: 1.05069,
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 576.93,
    cy: 245.368,
    rx: 0.929993,
    ry: 0.644981,
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 836.99,
    cy: 259.973,
    rx: 0.98999,
    ry: 0.686584,
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 872.59,
    cy: 263.857,
    rx: 1.59,
    ry: 1.10271,
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1145.59,
    cy: 275.647,
    rx: 1.59003,
    ry: 1.10272,
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1264.8,
    cy: 244.584,
    rx: 1.79999,
    ry: 1.24834,
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1313.19,
    cy: 249.706,
    rx: 1.185,
    ry: 0.821831,
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.82
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 98.945,
    cy: 355.279,
    rx: 0.945,
    ry: 0.65538,
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 246.29,
    cy: 303.504,
    rx: 1.29,
    ry: 0.894653,
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 392.44,
    cy: 343.833,
    rx: 1.44,
    ry: 0.998672,
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 510.665,
    cy: 314.167,
    rx: 1.66501,
    ry: 1.15472,
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.87
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 702.455,
    cy: 316.795,
    rx: 1.45499,
    ry: 1.00909,
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 838.44,
    cy: 353.542,
    rx: 1.44,
    ry: 0.998688,
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 959.005,
    cy: 353.24,
    rx: 1.005,
    ry: 0.697006,
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1043.09,
    cy: 345.674,
    rx: 1.09497,
    ry: 0.759415,
    fill: "white"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1159.14,
    cy: 349.866,
    rx: 1.14001,
    ry: 0.790619,
    fill: "white"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.91
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1432.16,
    cy: 329.764,
    rx: 1.15503,
    ry: 0.801025,
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 121.9,
    cy: 364.588,
    rx: 0.900002,
    ry: 0.624176,
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 184.155,
    cy: 392.506,
    rx: 1.155,
    ry: 0.801025,
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 395.35,
    cy: 402.35,
    rx: 1.35001,
    ry: 0.936264,
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.73
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 453.455,
    cy: 385.778,
    rx: 1.455,
    ry: 1.00908,
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 618.38,
    cy: 379.484,
    rx: 1.38,
    ry: 0.957077,
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 845.96,
    cy: 398.612,
    rx: 0.959991,
    ry: 0.665787,
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 951.2,
    cy: 406.407,
    rx: 1.20001,
    ry: 0.83223,
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1022.02,
    cy: 378.541,
    rx: 1.01999,
    ry: 0.707397,
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1191.5,
    cy: 401.76,
    rx: 1.5,
    ry: 1.04028,
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1318.9,
    cy: 372.216,
    rx: 0.900024,
    ry: 0.624176,
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 45.335,
    cy: 472.71,
    rx: 1.335,
    ry: 0.925858,
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 170.245,
    cy: 431.035,
    rx: 1.245,
    ry: 0.863434,
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.91
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 430.29,
    cy: 478.92,
    rx: 1.28999,
    ry: 0.894653,
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 496.185,
    cy: 433.074,
    rx: 1.185,
    ry: 0.821838,
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 680.335,
    cy: 445.662,
    rx: 1.33499,
    ry: 0.925858,
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 753.11,
    cy: 474.634,
    rx: 1.10999,
    ry: 0.769821,
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 962.53,
    cy: 472.845,
    rx: 1.53,
    ry: 1.0611,
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1061.99,
    cy: 445.423,
    rx: 0.98999,
    ry: 0.6866,
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1166.09,
    cy: 446.882,
    rx: 1.09497,
    ry: 0.759415,
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1357.24,
    cy: 460.857,
    rx: 1.245,
    ry: 0.863434,
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 81.35,
    cy: 504.252,
    rx: 1.35,
    ry: 0.936264,
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 227.785,
    cy: 523.973,
    rx: 1.785,
    ry: 1.23795,
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 386.2,
    cy: 486.116,
    rx: 1.2,
    ry: 0.83223,
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 567.29,
    cy: 483.405,
    rx: 1.29001,
    ry: 0.894653,
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 679.035,
    cy: 494.324,
    rx: 1.035,
    ry: 0.717804,
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 790.365,
    cy: 487.618,
    rx: 1.36499,
    ry: 0.946655,
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1005.04,
    cy: 490.857,
    rx: 1.035,
    ry: 0.717804,
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1125.96,
    cy: 512.998,
    rx: 0.960022,
    ry: 0.665802,
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1169.29,
    cy: 490.34,
    rx: 1.28998,
    ry: 0.894653,
    fill: "white"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1352.5,
    cy: 482.857,
    rx: 1.5,
    ry: 1.04028,
    fill: "white"
  })), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.73
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 102.62,
    cy: 587.293,
    rx: 1.62,
    ry: 1.1235,
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 225.14,
    cy: 576.557,
    rx: 1.14,
    ry: 0.790619,
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 418.41,
    cy: 545.536,
    rx: 1.41,
    ry: 0.977875,
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.82
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 514.02,
    cy: 598.667,
    rx: 1.01999,
    ry: 0.707397,
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 596.305,
    cy: 555.172,
    rx: 1.30499,
    ry: 0.90506,
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 830.065,
    cy: 572.344,
    rx: 1.065,
    ry: 0.738617,
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 977.44,
    cy: 546.943,
    rx: 1.44,
    ry: 0.998688,
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1013.55,
    cy: 580.999,
    rx: 1.54501,
    ry: 1.0715,
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1171.22,
    cy: 541.239,
    rx: 1.21503,
    ry: 0.842621,
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1356.24,
    cy: 593.275,
    rx: 1.245,
    ry: 0.863464,
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 26.095,
    cy: 604.59,
    rx: 1.095,
    ry: 0.75943,
    fill: "white"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 199.425,
    cy: 623.545,
    rx: 1.425,
    ry: 0.988281,
    fill: "white"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.87
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 391.365,
    cy: 617.262,
    rx: 1.36501,
    ry: 0.946655,
    fill: "white"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 563.155,
    cy: 633.067,
    rx: 1.155,
    ry: 0.801025,
    fill: "white"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 622.975,
    cy: 644.038,
    rx: 0.975006,
    ry: 0.676178,
    fill: "white"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.91
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 817.23,
    cy: 651.844,
    rx: 1.23001,
    ry: 0.853027,
    fill: "white"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 874.305,
    cy: 650.509,
    rx: 1.30499,
    ry: 0.90506,
    fill: "white"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1113.8,
    cy: 623.805,
    rx: 1.79999,
    ry: 1.24835,
    fill: "white"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1195.36,
    cy: 647.083,
    rx: 1.36499,
    ry: 0.946686,
    fill: "white"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1355.2,
    cy: 610.212,
    rx: 1.20001,
    ry: 0.832245,
    fill: "white"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 94.26,
    cy: 717.38,
    rx: 1.26,
    ry: 0.873871,
    fill: "white"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 211.455,
    cy: 693.936,
    rx: 1.455,
    ry: 1.00909,
    fill: "white"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 295.59,
    cy: 684.32,
    rx: 1.59,
    ry: 1.10272,
    fill: "white"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 517.945,
    cy: 717.856,
    rx: 0.945007,
    ry: 0.655365,
    fill: "white"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 698.515,
    cy: 663.462,
    rx: 1.51501,
    ry: 1.05069,
    fill: "white"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 838.035,
    cy: 699.192,
    rx: 1.035,
    ry: 0.717804,
    fill: "white"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.87
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 913.74,
    cy: 718.407,
    rx: 1.73999,
    ry: 1.20673,
    fill: "white"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1046.38,
    cy: 666.143,
    rx: 1.38,
    ry: 0.957062,
    fill: "white"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.83
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1227.16,
    cy: 673.615,
    rx: 1.15503,
    ry: 0.801025,
    fill: "white"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1399.47,
    cy: 660.657,
    rx: 1.46997,
    ry: 1.01947,
    fill: "white"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 5.065,
    cy: 737.681,
    rx: 1.065,
    ry: 0.738617,
    fill: "white"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 269.185,
    cy: 729.442,
    rx: 1.185,
    ry: 0.821838,
    fill: "white"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 328.365,
    cy: 759.389,
    rx: 1.36501,
    ry: 0.946655,
    fill: "white"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 561.65,
    cy: 738.087,
    rx: 1.64999,
    ry: 1.14432,
    fill: "white"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 695.515,
    cy: 742.154,
    rx: 1.51501,
    ry: 1.05069,
    fill: "white"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 749.335,
    cy: 762.835,
    rx: 1.33499,
    ry: 0.925873,
    fill: "white"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 875.335,
    cy: 724.692,
    rx: 1.33499,
    ry: 0.925873,
    fill: "white"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1108.3,
    cy: 741.315,
    rx: 1.30499,
    ry: 0.90506,
    fill: "white"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1215.65,
    cy: 772.763,
    rx: 1.65002,
    ry: 1.14432,
    fill: "white"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.91
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1414.06,
    cy: 747.391,
    rx: 1.065,
    ry: 0.738617,
    fill: "white"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 110.335,
    cy: 818.641,
    rx: 1.335,
    ry: 0.925873,
    fill: "white"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 193.68,
    cy: 818.88,
    rx: 1.68,
    ry: 1.16513,
    fill: "white"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 350.005,
    cy: 817.719,
    rx: 1.005,
    ry: 0.696991,
    fill: "white"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 442.155,
    cy: 785.921,
    rx: 1.155,
    ry: 0.801025,
    fill: "white"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 594.32,
    cy: 803.373,
    rx: 1.32001,
    ry: 0.915466,
    fill: "white"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 825.96,
    cy: 829.477,
    rx: 0.959991,
    ry: 0.665802,
    fill: "white"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.73
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 962.975,
    cy: 812.843,
    rx: 0.975006,
    ry: 0.676178,
    fill: "white"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1064.12,
    cy: 781.045,
    rx: 1.125,
    ry: 0.780212,
    fill: "white"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1251.26,
    cy: 786.687,
    rx: 1.26001,
    ry: 0.87384,
    fill: "white"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1348.06,
    cy: 817.76,
    rx: 1.065,
    ry: 0.738617,
    fill: "white"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 37.005,
    cy: 890.169,
    rx: 1.005,
    ry: 0.696991,
    fill: "white"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 264.095,
    cy: 875.668,
    rx: 1.095,
    ry: 0.759399,
    fill: "white"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 381.56,
    cy: 860.732,
    rx: 1.56,
    ry: 1.08191,
    fill: "white"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 525.44,
    cy: 880.761,
    rx: 1.44,
    ry: 0.998657,
    fill: "white"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 668.785,
    cy: 841.469,
    rx: 1.785,
    ry: 1.23795,
    fill: "white"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 811.59,
    cy: 898.897,
    rx: 1.59,
    ry: 1.10272,
    fill: "white"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 870.9,
    cy: 881.08,
    rx: 0.899994,
    ry: 0.624176,
    fill: "white"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1110.72,
    cy: 853.218,
    rx: 1.72498,
    ry: 1.19632,
    fill: "white"
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1158.32,
    cy: 877.904,
    rx: 1.32001,
    ry: 0.915466,
    fill: "white"
  })), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1372.74,
    cy: 845.6,
    rx: 1.73999,
    ry: 1.20673,
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 1324,
    cy: 450,
    r: 449,
    fill: "#4B48C1",
    fillOpacity: 0.3,
    stroke: "white",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 1324,
    cy: 450,
    r: 216.663,
    fill: "#4B48C1",
    fillOpacity: 0.4,
    stroke: "white",
    strokeWidth: 2
  })), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1810_27684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1341.07 334.733C1347.34 310.987 1333.19 286.647 1309.46 280.368C1285.74 274.09 1261.42 288.25 1255.14 311.997C1248.87 335.743 1263.02 360.083 1286.75 366.361C1310.47 372.64 1334.79 358.479 1341.07 334.733Z",
    fill: "url(#paint0_linear_1810_27684)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.33 322.42C1344.33 322.42 1348.83 323.768 1356.6 326.619C1360.49 328.07 1365.15 329.884 1370.38 332.321C1376.49 334.849 1382.16 338.35 1387.16 342.687C1388.02 343.448 1388.71 344.371 1389.21 345.403C1389.71 346.435 1390 347.556 1390.06 348.7C1390.13 349.112 1390.13 349.533 1390.06 349.944V350.566C1389.71 351.236 1389.23 351.834 1388.66 352.329C1387.77 353.082 1386.75 353.677 1385.66 354.091C1381.69 355.402 1377.55 356.101 1373.38 356.164C1364.73 356.435 1356.07 355.984 1347.49 354.817C1328.98 352.389 1310.65 348.805 1292.59 344.087C1274.66 339.299 1257.05 333.396 1239.86 326.411C1231.86 323.29 1224.14 319.51 1216.76 315.111C1213.16 312.926 1209.91 310.199 1207.13 307.025C1206.4 306.126 1205.82 305.11 1205.42 304.019C1205.14 303.372 1205 302.675 1205 301.971C1205 301.267 1205.14 300.571 1205.42 299.924C1206.03 298.818 1206.95 297.916 1208.06 297.332C1208.97 296.831 1209.92 296.431 1210.91 296.14C1217.5 294.782 1224.28 294.519 1230.95 295.362C1236.7 295.881 1241.68 296.555 1245.77 297.229C1253.9 298.576 1258.51 299.665 1258.51 299.665C1258.51 299.665 1253.85 299.095 1245.61 298.421C1241.31 298.058 1236.13 297.747 1230.7 297.643C1224.44 297.433 1218.18 298.078 1212.1 299.561C1211.46 299.742 1210.83 299.985 1210.24 300.287C1210 300.399 1209.79 300.558 1209.62 300.753C1209.5 300.934 1209.39 301.125 1209.31 301.323C1208.89 301.842 1209.31 303.138 1210.55 304.382C1213.05 307.006 1215.91 309.258 1219.04 311.068C1226.42 314.989 1234.03 318.452 1241.83 321.435C1258.91 328.073 1276.38 333.647 1294.14 338.126C1311.79 343.019 1329.73 346.81 1347.85 349.478C1356.12 350.72 1364.45 351.447 1372.81 351.655C1380.11 351.655 1390.78 350.463 1384.67 344.916C1380.01 340.659 1374.78 337.066 1369.13 334.238C1363.96 331.491 1359.66 329.314 1355.88 327.604C1348.68 324.286 1344.33 322.42 1344.33 322.42Z",
    fill: "url(#paint1_linear_1810_27684)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1810_27684",
    x1: 1255.14,
    y1: 311.997,
    x2: 1341.08,
    y2: 334.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F2",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1810_27684",
    x1: 1297.56,
    y1: 294.879,
    x2: 1297.56,
    y2: 356.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F2",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1810_27684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 108.73,
    fill: "white",
    transform: "translate(1205 269)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeBg);
export default __webpack_public_path__ + "static/media/welcome_bg.a687ecd4529468064cea7df9e219b01c.svg";
export { ForwardRef as ReactComponent };